<template>
	<div>
		<b-row>
			<b-col md="12" class="mb-4">
				<h6>Null</h6>
				<parameter-id-selectbox v-model="value1" sort="code" code="days"/>
				<span>{{ value1 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Single Selected</h6>
				<parameter-id-selectbox v-model="value2" sort="code" code="days"/>
				<span>{{ value2 }}</span>
			</b-col>
			<b-col md="12" class="mb-4">
				<h6>Validate Error</h6>
				<parameter-id-selectbox v-model="value3" sort="code" code="days" :validate-error="value3ValidateError"/>
				<span>{{ value3 }}</span>
			</b-col>
			<b-col cols="12">
				<b-button variant="primary" @click="change()">
					{{ $t('change').toUpper() }}
				</b-button>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import ParameterIdSelectbox from "@/components/interactive-fields/ParameterIdSelectbox";

	export default {
		components: {
			ParameterIdSelectbox,
		},
		data() {
			return {
				value1: null,
				value2: 534,
				value3: 534,
				value3ValidateError: 'Validate Error is Working',
			}
		},
		methods: {
			change() {
				this.value2 = 528
				this.value3 = 528
				this.value3ValidateError = 'Error'
			}
		}
	};
</script>

